import React, { useCallback, useEffect, useRef, useState } from 'react';
import './navbar.css';
import logo from './pages/mainlogo.png';
import { FaBars } from 'react-icons/fa';
import { useLocation } from 'react-router-dom';

const Navbar: React.FC = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('hero');
  const navRef = useRef<HTMLDivElement>(null);
  const location = useLocation();

  const toggleNav = () => setIsNavOpen(!isNavOpen);

  const handleClickOutside = useCallback((event: { target: any }) => {
    if (navRef.current && !navRef.current.contains(event.target)) {
      setIsNavOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [handleClickOutside]);

  // Track active section on scroll (personal mode only)
  useEffect(() => {
    if (location.pathname !== '/') return;
    
    const sections = ['hero', 'about', 'dashboard', 'skills', 'experience', 'projects', 'connect'];
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.3 }
    );

    sections.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, [location.pathname]);

  const scrollTo = (id: string) => {
    setIsNavOpen(false);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const personalLinks = [
    { id: 'about', label: 'About' },
    { id: 'dashboard', label: 'Live' },
    { id: 'experience', label: 'Experience' },
    { id: 'projects', label: 'Projects' },
    { id: 'connect', label: 'Connect' },
  ];

  return (
    <nav className="navbar" ref={navRef}>
      <div className="navbar-left">
        <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('hero'); }}>
          <img src={logo} alt="logo" className="logo" />
        </a>
      </div>
      <div className="toggle-button" onClick={toggleNav}>
        <FaBars />
      </div>
      <ul className={`navbar-links ${isNavOpen ? 'active' : ''}`}>
        {personalLinks.map((link) => (
          <li key={link.id} className={`under ${activeSection === link.id ? 'active-link' : ''}`}>
            <a href={`#${link.id}`} onClick={(e) => { e.preventDefault(); scrollTo(link.id); }}>
              {link.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Navbar;
